import "core-js/modules/es6.object.assign";
import { __rest } from "tslib";
import * as React from 'react';
import AngleDownIcon from '@patternfly/react-icons/dist/js/icons/angle-down-icon';
import { css } from '@patternfly/react-styles';
import { Button } from '@patternfly/react-core/dist/js/components/Button/Button';
import styles from '@patternfly/react-styles/css/components/Table/table';
export var CollapseColumn = function CollapseColumn(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      isOpen = _a.isOpen,
      onToggle = _a.onToggle,
      props = __rest(_a, ["className", "children", "isOpen", "onToggle"]);

  return React.createElement(React.Fragment, null, isOpen !== undefined && React.createElement(Button, Object.assign({
    className: css(className, isOpen && styles.modifiers.expanded)
  }, props, {
    variant: "plain",
    "aria-label": "Details",
    onClick: onToggle,
    "aria-expanded": isOpen
  }), React.createElement("div", {
    className: css(styles.tableToggleIcon)
  }, React.createElement(AngleDownIcon, null))), children);
};
CollapseColumn.displayName = 'CollapseColumn';